<template>
  <div>
    <span>
      &nbsp;&nbsp;
      <a @click="onClickRu"><img src="../../../assets/ru.png"></a>&nbsp;&nbsp;
      <a @click="onClickEn"><img src="../../../assets/en.png"></a>&nbsp;&nbsp;
    </span>
  </div>
</template>

<script>
export default {
  name: 'PanelLocale',
  methods: {
    onClickEn() {
      this.$i18n.locale = 'en';
      window.localStorage.setItem('locale', 'en');
    },
    onClickRu() {
      this.$i18n.locale = 'ru';
      window.localStorage.setItem('locale', 'ru');
    }
  }
}
</script>

<style scoped>
  div {
    margin-left: 227px;
    margin-bottom: 11px;
  }

  span {
    background-color: #D3E2F0;
    padding: 5px 3px 5px 3px;
    border-radius: 3px;
  }

  a {
    color: #6690C9;
    cursor: pointer;
  }
</style>


